'use strict';



const $ = require('jquery');
const classNamespace = 'js-tabbed-content';
const EventEmitter = require('events');
const containerClassName = `${classNamespace}-container`;
const contentClassName = `${classNamespace}-content`;
const $instances = $(`.${containerClassName}`);
const $contents = $(`.${contentClassName}`);
const activeLinkClassName = 'is-active';
const browserCanReplaceState = typeof history !== 'undefined' && typeof history.replaceState === 'function';
let $default;
let activeHash;



const setLocation = browserCanReplaceState ?
  history.replaceState.bind(history, null, null) :
  function() {};



module.exports = function init () {

  const emitter = new EventEmitter();
  const doRoute = route(emitter)

  if($instances.length === 0) {
    return;
  }

  const $link = $(`[href^='#']`);
  $default = $instances.filter('.is-default');

  if($default.size() === 0) {
    $default = $instances.eq(0);
  }

  $instances.css({
    position: 'absolute',
    top: 0,
    marginTop: 0
  });

  emitter.on('route', hash => {
    setLinkStates(hash);
  });

  setTimeout(doRoute, 0);
  $(window).on('hashchange', doRoute);

  $link.on('click', function(e) {
    doRoute($(this).attr('href'), e);
  });

  return emitter;

}



const route = emitter => (destination = location.hash, e = null) => {

  if(destination === '#') {
    return;
  }

  const $match = $instances.filter(destination);

  if($match.length > 0) {

    if(e) {
      e.preventDefault();
    }

    emitter.emit('route', destination);
    return dispatch($match, destination);

  }

  emitter.emit('route', `#${$default.attr('id')}`);
  dispatch($default);

}



function dispatch($match, destination) {

  $contents.hide();
  $match.find(`.${contentClassName}`).show();

  $match.css({ position: 'relative' });

  if(destination) {
    setLocation(destination);
  }

}



function setLinkStates(hash) {

  const $inactive = $(`[href='${activeHash}']`);
  const $active = $(`[href='${hash}']`);

  $inactive.removeClass(activeLinkClassName);
  $active.addClass(activeLinkClassName);

  activeHash = hash;

}
